import { render, staticRenderFns } from "./UploadArrow.vue?vue&type=template&id=c9d78342"
import script from "./UploadArrow.vue?vue&type=script&lang=js"
export * from "./UploadArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports